export default __webpack_public_path__ + "static/grouped-bar-1edee74a188e4291ff2132b103a1bd44.png";